import { render } from "./ContactItem.vue?vue&type=template&id=792d670a&scoped=true"
import script from "./ContactItem.vue?vue&type=script&lang=js"
export * from "./ContactItem.vue?vue&type=script&lang=js"

import "./ContactItem.vue?vue&type=style&index=0&id=792d670a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792d670a"]])

export default __exports__